<template>
  <div>
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <!--快递-->
      <el-tab-pane :label="$t('collectionCenter.expressDelivery')" name="expressDelivery">
        <expressDelivery />
      </el-tab-pane>
      <!--揽收-->
      <el-tab-pane :label="$t('collectionCenter.collect')" name="collect">
        <collect />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import expressDelivery from './cmp/expressDelivery.vue';
import collect from './cmp/collect.vue';
export default {
  name: 'NfseDataCheck',
  components: {
    expressDelivery,
    collect
  },
  data() {
    return {
      activeName: 'expressDelivery'
    };
  },
  methods: {
    // 标签切换
    handleClick(tab) {
      console.log(tab);
    }
  }
};
</script>
<style>
.numberSearch .el-input--small .el-input__inner {
  line-height: 28px;
  height: 28px;
  border: none;
  padding-left: 0;
  font-weight: bold;
}
</style>
